import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import keycode from 'keycode';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import {DatePicker} from 'material-ui-pickers';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';

import {BASE_URL_JAVAZ_API} from 'constants/ActionTypes';

const apiUrlHeader = BASE_URL_JAVAZ_API;
const apiUrl = apiUrlHeader+"/vendor";
const masterTitleLower = "vendor";
const masterTitleCapital = "Vendor";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 20

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
      flex: {
        flex: 1,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

const MySnackbarContentWrapper = withStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    iconSnack: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }))(MySnackbarContent);

class DialogForm extends React.Component {

    //handle company dd add
    callbackCompany = ({id}) => {
        this.setState({companyIdForm: id})
    };
    //handle company dd add
    callbackVendor = ({id}) => {
        this.setState({typeForm: id})
    };
    // end function ==============================================================================

    async componentDidMount() {
        this.props.showDialog(this.showDialog);
        // console.log("here did mount");
    };

    async componentDidUpdate() {
        
        if(this.state.isParentClick == true){
            if(this.props.idData == 0 ){
                this.setState({
                    openDialog: true,
                    action: "tambah",
                    
                    companyIdForm:companyIdGlobal,
                    codeForm: "",
                    nameForm: "",
                    phoneForm: "",
                    faxForm: "",
                    typeForm: 0,
                    websiteForm: "",
                    picNameForm: "",
                    picEmailForm: "",
                    picPhoneForm: "",
                    picTitleForm: "",
                    npwpNoForm: "",
                    npwpAddressForm: "",
                    descriptionForm: ""

                })
            }else{
                this.setState({action: "ubah"});
                this.handleClickOpenEdit(this.props.idData);
            }
            this.setState({ isParentClick : false });
        }
        
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            openDialog: false,
            isParentClick: false,
            action: "tambah",

            //snackbar state
            openSnackSuccess: false,
            openSnackErr: false,
            messageSnackBar:"",

            idData:0,

            //FORM================================================
            companyIdForm:companyIdGlobal,
            codeForm: "",
            nameForm: "",
            phoneForm: "",
            faxForm: "",
            typeForm: 0,
            websiteForm: "",
            picNameForm: "",
            picEmailForm: "",
            picPhoneForm: "",
            picTitleForm: "",
            npwpNoForm: "",
            npwpAddressForm: "",
            descriptionForm: "",
            loading: false
        };

        this.showDialog = this.showDialog.bind(this);
    };

    showDialog() {
        
        this.setState({ isParentClick : true });
    };

    // logic new ================================================================================
    handleClose = async(param) => {
        if(param === 'batal'){
            
            this.setState({ idData:0, openDialog: false });
            this.props.closeDialog(); 
        } else if (param === 'tambah') {
            this.setState({idData:0, loading: true})
        
            const data = {
                "name" : this.state.nameForm,
                "company" : parseInt(this.state.companyIdForm),
                "code": this.state.codeForm,
                "phone": this.state.phoneForm,
                "fax": this.state.faxForm,
                "business_type": this.state.typeForm,
                "website": this.state.websiteForm,
                "cp_name_1": this.state.picNameForm,
                "cp_phone_1": this.state.picPhoneForm,
                "cp_email_1": this.state.picEmailForm,
                "cp_title_1": this.state.picTitleForm,
                "npwp_no": this.state.npwpNoForm,
                "npwp_address": this.state.npwpAddressForm,
                "description": this.state.descriptionForm
            }

            let obj = JSON.stringify(data);
            
            const result = await axios.post(apiUrl+'/new', obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.code === 201){
                NotificationManager.success("Success insert "+masterTitleLower+" data", 'Success message') 
                this.setState({ openDialog: false, loading: false });
                this.props.closeDialog(result.data); 
            }else{
                this.setState({loading: false})
                NotificationManager.error("Failed insert "+masterTitleLower+" data : "+result.data.message, 'Error message')
            }     
        } else if (param === 'ubah') {
            const {idData} = this.state
            this.setState({loading: true})
            const data = {
                "name" : this.state.nameForm,
                "company" : parseInt(this.state.companyIdForm),
                "code": this.state.codeForm,
                "phone": this.state.phoneForm,
                "fax": this.state.faxForm,
                "business_type": this.state.typeForm,
                "website": this.state.websiteForm,
                "cp_name_1": this.state.picNameForm,
                "cp_phone_1": this.state.picPhoneForm,
                "cp_email_1": this.state.picEmailForm,
                "cp_title_1": this.state.picTitleForm,
                "npwp_no": this.state.npwpNoForm,
                "npwp_address": this.state.npwpAddressForm,
                "description": this.state.descriptionForm
            }
            let obj = JSON.stringify(data);    
            const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.code === 200){
                
                NotificationManager.success("Success update "+masterTitleLower+" data", 'Success message') 
                
                this.setState({ openDialog: false, loading: false });
                this.props.closeDialog(result.data);  
            }else{
                this.setState({loading: false})
                NotificationManager.error("Failed update "+masterTitleLower+" data : "+result.data.message, 'Error message')
                
            }
        }
        
    };


    //logic open edit ===========================================================================
    handleClickOpenEdit = async(id) => {
        this.setState({openDialog: true, idData:id})

        const result = await axios.get(`${apiUrl}/${id}`, config)
                            .then(res => res)
                            .catch((error) => error.response )

        // let dataConfig = {
        //     joins : [
        //                 {name:"company",column_results:["name"]},
        //                 {name:"business_type",column_results:["name"]}
        //             ],
        //     columns : [
        //             {name:"id","logic_operator":"=",value:"37","operator":"AND"},
        //             ]
        // }
        // let obj = JSON.stringify(dataConfig)
        // const result = await axios.post(apiUrl+'/search', obj, config)
        //                     .then(res => res)
        //                     .catch((error) => error.response)

        if(result.data.code === 200){
            // console.log(result.data.data.business_type);
            this.setState({
                companyIdForm:result.data.data.company,
                codeForm: result.data.data.code,
                nameForm:result.data.data.name,
                phoneForm: result.data.data.phone,
                faxForm: result.data.data.fax,
                typeForm: result.data.data.business_type,
                websiteForm: result.data.data.website,
                picNameForm: result.data.data.cp_name_1,
                picPhoneForm: result.data.data.cp_phone_1,
                picEmailForm: result.data.data.cp_email_1,
                picTitleForm: result.data.data.cp_title_1,
                npwpNoForm: result.data.data.npwp_no,
                npwpAddressForm: result.data.data.npwp_address,
                descriptionForm: result.data.data.description
            })      
        }
                         
    };

    // end function vendor =================================================================
    
    render() {
        const {classes} = this.props
        const {loading} = this.state
        return (
            <div>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackSuccess}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackSuccess: false })}
                >
                  <MySnackbarContentWrapper
                    onClose={()=> this.setState({ openSnackSuccess: false })}
                    variant="success"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackErr}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackErr: false })}
                >
                  <MySnackbarContentWrapper
                  onClose={()=> this.setState({ openSnackErr: false })}
                    variant="error"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>

                <NotificationContainer/>
                    
                <Dialog
                fullScreen
                open={this.state.openDialog}
                onClose={() => this.handleClose('batal')}
                TransitionComponent={Transition}
                >
                <AppBar className="sticky-container">
                    <Toolbar>
                    <Typography variant="h6" color="inherit" className={classes.flex}>
                        {masterTitleCapital}
                    </Typography>
                    <Button 
						variant="raised" 
						disabled={loading}
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						className="bg-white text-black" 
						onClick={() => { if(!loading) this.handleClose('batal')}}
					>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button 
						variant="raised" 
						color="primary" 
						disabled={loading} 
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						onClick={() => { if(!loading) this.handleClose(this.state.action) }}
					>		 
						{loading ? (
							<CircularProgress
								className="text-white"
								size={24}
							/>						  
						) : this.state.action}
                    </Button>
                    </Toolbar>
                </AppBar>
                <br/>
                <br/>
                <div className="app-wrapper">
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Grid item xs={12}>
                                <InputVirtual 
                                    label="Perusahaan"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={apiUrlHeader+"/company/search"}
                                    getData={this.callbackCompany}
                                    setData={[{name:"id",value:this.state.companyIdForm,"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormCompany"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Code"
                                  // className={classes.textField}
                                  value={this.state.codeForm}
                                  fullWidth
                                  onChange={(e) => this.setState({codeForm: e.target.value})}

                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Nama"
                                  // className={classes.textField}
                                  value={this.state.nameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({nameForm: e.target.value})}

                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Phone No."
                                  // className={classes.textField}
                                  value={this.state.phoneForm}
                                  fullWidth
                                  onChange={(e) => this.setState({phoneForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="Fax"
                                  // className={classes.textField}
                                  value={this.state.faxForm}
                                  fullWidth
                                  onChange={(e) => this.setState({faxForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                
                                <InputVirtual 
                                    label="Type"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={apiUrlHeader+"/business-type/search"}
                                    getData={this.callbackVendor}
                                    setData={[{name:"id",value:this.state.typeForm.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormBusinessType"
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="Website"
                                  // className={classes.textField}
                                  value={this.state.websiteForm}
                                  fullWidth
                                  onChange={(e) => this.setState({websiteForm: e.target.value})}

                                />
                                
                            </Grid>

                        </Grid>

                        <Grid item xs={6}>
                            
                            <Grid item xs={12}>
                                <TextField
                                  label="PIC Name"
                                  // className={classes.textField}
                                  value={this.state.picNameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picNameForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="PIC Phone"
                                  // className={classes.textField}
                                  value={this.state.picPhoneForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picPhoneForm: e.target.value})}

                                />
                                
                            </Grid>
                            
                            <Grid item xs={12}>
                                <TextField
                                  label="PIC Email"
                                  // className={classes.textField}
                                  value={this.state.picEmailForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picEmailForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="PIC Title"
                                  // className={classes.textField}
                                  value={this.state.picTitleForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picTitleForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="NPWP Number"
                                  // className={classes.textField}
                                  value={this.state.npwpNoForm}
                                  fullWidth
                                  onChange={(e) => this.setState({npwpNoForm: e.target.value})}

                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="NPWP Address"
                                  // className={classes.textField}
                                  value={this.state.npwpAddressForm}
                                  fullWidth
                                  onChange={(e) => this.setState({npwpAddressForm: e.target.value})}

                                />
                                
                            </Grid>
                            
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                              label="Deskripsi"
                              // className={classes.textField}
                              value={this.state.descriptionForm}
                              fullWidth
                              onChange={(e) => this.setState({descriptionForm: e.target.value})}
                            />
                            
                        </Grid>
                        
                    </Grid>
                </div>
                </Dialog>
                
                    
               
            </div>
        );
    }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterVendor/DialogForm.js